import React from "react";
import ProductCard from "../../shared/ProductCard";
import SliderComponent from "./SliderComponent";

const uuid = require("uuid/v1");

const ProductSlider = (props) => {
  const {
    products,
    backgroundColor,
    textColor,
    borderColor,
    key,
    arrowColor,
    showArrows,
  } = props;
  const colors = { backgroundColor, textColor, borderColor };
  if (products.length === 0) return null;

  return (
    <SliderComponent
      key={key}
      direction={"center"}
      sliderId={uuid()}
      arrowColor={arrowColor}
      showArrows={showArrows}
    >
      {products.map((product) => {
        return <ProductCard
           className="product-slider-card"
           colors={colors} key={product.id}
           {...product}  />;
      })}
    </SliderComponent>
  );
};

export default ProductSlider;
